// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1c7Dj","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__l68mg"};